// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  ritualId: __t.u64().primaryKey().name("ritual_id"),
  eventId: __t.u64().name("event_id"),
  repetitions: __t.u32(),
  institutionalized: __t.bool(),
  npcHostId: __t.u64().name("npc_host_id"),
  lastSessionAt: __t.timestamp().name("last_session_at"),
  humansThisSession: __t.u32().name("humans_this_session"),
  humansLastSession: __t.u32().name("humans_last_session"),
});
